var _rect, _path, _path2, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 39.2C9 39.2 13.5217 44 18.2174 44C22.913 44 22.913 54.0364 27.6087 54.0364C32.3043 54.0364 32.3043 29.6 37 29.6C41.5217 29.6 41.5217 42.6909 46.2174 42.6909C50.913 42.6909 50.913 20 55.6087 20C60.3043 20 65 43.5636 65 43.5636",
    stroke: "#00B42A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 56.4C9 56.4 13.5217 25.4182 18.2174 25.4182C22.913 25.4182 22.913 18 27.6087 18C32.3043 18 32.3043 45.0545 37 45.0545C41.5217 45.0545 41.5217 42.4364 46.2174 42.4364C50.913 42.4364 50.913 43.7455 55.6087 43.7455C60.3043 43.7455 65 31.9636 65 31.9636",
    stroke: "#4285F4",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 72,
    rx: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.747662870ad99e34e6ef7e23404742e7.svg";
export { ForwardRef as ReactComponent };